import axios from 'axios'
import { getBrandName } from '@/helpers/BrandHelper'

function setDictionaryPhrasesArray(phrasesArray) {
  let phrases = {}
  for (let phrase of phrasesArray) {
    phrases[phrase.Name] = phrase.Label
  }
  setDictionaryPhrases(phrases)
}

function setDictionaryPhrases(phrases) {
  //workaround for ServiceClusters
  //when dictionary entry exists and its value is empty, then ServiceClusters use entry key as value
  //we override it back to empty
  for (var key in phrases) {
    if (key === phrases[key]) phrases[key] = ''
  }

  //backward compatibility
  //normalize all labels to lowercase
  for (var key in phrases) {
    let lowerCaseKey = key.toLowerCase()
    phrases[lowerCaseKey] = phrases[key]
  }

  window.VUE_CLI_EXPORTS.plugins.i18n.setLocaleMessage('nl', phrases)
}

export default {
  async getDictionaryLabels() {
    return await axios.get(`GetTranslations`)
  },

  async initDictionaryTranslations() {
    try {
      await this.getDictionaryLabels().then((response) => {
        setDictionaryPhrasesArray(response.data)
      })
    } catch (e) {
      console.error('Failed to fetch translations for brand ' + getBrandName(), e)
    }
  },
}
